import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 14,
  small: 14,
  xSmall: 12
};
const CheckmarkIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "xSmall":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.9601 3.27002L13.7127 3.92852L6.03151 12.707L2.30005 8.97556L3.00716 8.26845L5.98216 11.2436L12.9601 3.27002Z",
              fill: "currentColor"
            }
          )
        );
      case "small":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            fill: "none",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16.2853 4.5L17 5.15557L8.59735 15.5L3 10.7495L3.57941 9.97664L8.46677 14.1253L16.2853 4.5Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      case "large":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21.2853 9L22 9.65557L13.5973 20L8 15.2495L8.57941 14.4766L13.4668 18.6253L21.2853 9Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
CheckmarkIcon.iconName = "CheckmarkIcon";

export { CheckmarkIcon };
